import axios from 'axios';
import store from 'store';

const state = {
  cancelSource: undefined,
  jobs: {},
  jobsToday: {},
  jobsTomorrow: {},
  jobsUpcoming: {},
  jobsCompleted: {},
  jobsIncomplete: {},
  job: {},
};

const getters = {
  getJobsFiltered: st => query => {
    if (typeof st.cancelSource !== typeof undefined) {
      st.cancelSource.cancel();
    }
    st.cancelSource = axios.CancelToken.source();
    axios
      .get(`jobs/list?${query}`, { cancelToken: st.cancelSource.token })
      .then(res => {
        st.jobs = res.data;
        st.cancelSource = undefined;
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          throw err;
        }
      });
  },
  getJobsToday: st => (query, moveDate) => {
    if (
      store.get('permissions') &&
      (store.get('permissions').indexOf('jobs.index') >= 0 ||
        store.get('permissions').indexOf('jobs.index-own') >= 0)
    ) {
      axios.get(`jobs/dashboard?move_date=${moveDate}&${query}`).then(res => {
        st.jobsToday = res.data;
      });
    }
  },
  getJobsTomorrow: st => (query, moveDate) => {
    if (
      store.get('permissions') &&
      (store.get('permissions').indexOf('jobs.index') >= 0 ||
        store.get('permissions').indexOf('jobs.index-own') >= 0)
    ) {
      axios.get(`jobs/dashboard?move_date=${moveDate}&${query}`).then(res => {
        st.jobsTomorrow = res.data;
      });
    }
  },
  getJobsUpcoming: st => (query, dateTo, dateFrom) => {
    axios.get(`jobs/dashboard?date_from=${dateFrom}&date_to=${dateTo}&${query}`).then(res => {
      st.jobsUpcoming = res.data;
    });
  },
  getJobsCompleted: st => query => {
    axios.get(`jobs/dashboard/completed?${query}`).then(res => {
      st.jobsCompleted = res.data;
    });
  },
  getJobsIncomplete: st => query => {
    axios.get(`jobs/dashboard/incomplete?${query}`).then(res => {
      st.jobsIncomplete = res.data;
    });
  },
};

const mutations = {
  setJobs: (st, payload) => {
    st.jobs = payload;
  },
  setJobsToday: (st, payload) => {
    st.jobsToday = payload;
  },
  setJobsTomorrow: (st, payload) => {
    st.jobsTomorrow = payload;
  },
  setJobsCompleted: (st, payload) => {
    st.jobsCompleted = payload;
  },
  setJobsIncomplete: (st, payload) => {
    st.jobsIncomplete = payload;
  },
  setJobsUpcoming: (st, payload) => {
    st.jobsUpcoming = payload;
  },
  setJob: (st, payload) => {
    st.job = payload;
  },
};

const actions = {
  getJobs({ commit }) {
    commit('setJobs', {});
    if (
      store.get('permissions').indexOf('jobs.index') >= 0 ||
      store.get('permissions').indexOf('jobs.index-own') >= 0
    ) {
      axios.get(`jobs/list`).then(res => {
        commit('setJobs', res.data);
      });
    }
  },
  getJob: ({ commit }, jobId) => {
    axios.get(`/jobs/${jobId}`).then(res => {
      commit('setJob', res.data);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js